import { render, staticRenderFns } from "./PrecioListItem.vue?vue&type=template&id=16be9178&scoped=true&"
import script from "./PrecioListItem.vue?vue&type=script&lang=js&"
export * from "./PrecioListItem.vue?vue&type=script&lang=js&"
import style0 from "./PrecioListItem.vue?vue&type=style&index=0&id=16be9178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16be9178",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCheckbox,VChip,VCol,VDivider,VIcon,VImg,VList,VListItem,VListItemIcon,VListItemTitle,VMenu,VRow,VSwitch,VTooltip})
